/* eslint-disable react/prop-types */
import React from "react";
import { useEffect, useState } from "react";
import Navigation from "../../components/navigation/Navigation";
import PageHeader from "../../components/pageHeader/PageHeader";
import NavbarBottomService from "./service/NavigationService";

const NavbarBottom = ({ id, short_url, hideTitle, hasAIAccess }) => {
  const [menu, setMenu] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const [navItem, setNavItem] = useState("");

  const pathname = window.location.pathname;
  const search = window.location.search;
  const currentLink = pathname + search;

  const regroupMenu = (menu) => {
    const favorites = menu.splice(menu.length - 1, 1);
    favorites[0].menu.sort((a, b) => (a.itemName > b.itemName ? 1 : -1));

    menu.splice(1, 0, ...favorites);
    menu.sort((a, b) => a.order - b.order);
  };

  const getMenu = async () => {
    let params = {
      short_url
    };

    let menuData = await NavbarBottomService.getMenu(params);

    if (menuData) {
      regroupMenu(menuData);
      setMenu(menuData);
      extractPageTitle(menuData);
    }

    // else {
    //   setError(() => {
    //     throw new Error("menu is empty");
    //   });
    // }
  };

  const extractPageTitle = (menu) => {
    if (menu) {
      for (let item of menu) {
        let foundedItem = !item.itemLink
          ? item.menu.find((navItem) => {
              if (item.itemName === "Custom") {
                return navItem.itemLink === currentLink;
              }
              return navItem.itemLink.split("?")[0] === pathname;
            })
          : item.itemLink.includes(pathname)
          ? item
          : "";
        if (foundedItem) {
          setPageTitle(foundedItem.itemName);
          setNavItem(item.itemName);
        }
        if (foundedItem && foundedItem.itemName === menu[0].itemName) {
          break;
        }
      }
    }
  };

  const toggleFavorite = async (isFavoriteEnabled) => {
    setIsFavoriteLoading(true);
    let params = { id, is_favorite: String(isFavoriteEnabled), page: pageTitle };
    let isToggled = await NavbarBottomService.toggleFavorite(params);

    if (isToggled) {
      setIsFavorite(isFavoriteEnabled);
      getMenu();
    }
    setIsFavoriteLoading(false);
  };

  useEffect(() => {
    getMenu();
  }, []);

  useEffect(() => {
    if (menu) {
      menu[1].menu.forEach((favorites) => {
        if (favorites.itemName === pageTitle) {
          setIsFavorite(true);
        }
      });
    }
  }, [pageTitle]);

  return (
    <>
      {menu ? (
        <>
          <div className="navbar-bottom__menu">
            <Navigation
              menu={menu}
              selectedMenuItem={pageTitle}
              activeNavItem={navItem}
              hasAIAccess={hasAIAccess}
            />
          </div>
          <div className="navbar-bottom__page-header">
            <PageHeader
              withFavorite={pageTitle ? pageTitle !== menu[0].itemName : false}
              pageTitle={pageTitle}
              isFavorite={isFavorite}
              isFavoriteLoading={isFavoriteLoading}
              toggleFavorite={(isFavoriteEnabled) => toggleFavorite(isFavoriteEnabled)}
            />
          </div>
        </>
      ) : (
        <>
          <div className="navbar-bottom__menu" style={{ height: "3.8rem", marginBottom: 0 }}></div>
          {hideTitle ? <div style={{ height: "2.5rem" }} /> : <div style={{ height: "5.2rem" }} />}
        </>
      )}
    </>
  );
};

export default NavbarBottom;
